import React from 'react';
import classes from '../searchResults.module.css';

var NoResults = function NoResults(_ref) {
  var geoError = _ref.geoError;
  return React.createElement("div", {
    className: classes.noResults
  }, !geoError ? React.createElement("p", {
    className: "w-full flex justify-center"
  }, "We are sorry, we could\u2019t find any results.") : React.createElement("div", {
    className: "w-full flex flex-col justify-center text-center"
  }, React.createElement("h6", {
    className: "font-bold mb-5"
  }, "We are unable to access your exact location"), React.createElement("p", null, "To find a Hubbardton Forge store, use the search feature, navigate using the map, or turn on location services.")));
};

export default NoResults;